import purchaseReceiveAPI from '@/services/API/purchase-receive';
import moment from 'moment';
import ItemAPI from '@/services/API/items'
import Promise from 'bluebird'
import { Message } from 'element-ui';

const reset = function({ commit }) {
  commit('RESET_STATE');
};

const setPurchaseReceiveProp = function({state,commit,dispatch}, purchaseReceive){
  _.forEach(['items','date', 'notes', 'purchaseOrderId','inventoryId','receiveAll'],prop=>{
    if(purchaseReceive.hasOwnProperty(prop)){
      commit('SET_PURCHASE_RECEIVE_PROPERTY', {propName : prop, propVal:purchaseReceive[prop]});
      if(prop=='date' && state.inventory_limit!=null){
        commit('SET_PURCHASE_RECEIVE_PROPERTY', {propName : 'sell_before', propVal:moment(purchaseReceive[prop]).add(state.inventory_limit,'days').format()});
      }
    }
  })
}

const setLineProp = function ({ commit, dispatch, state }, {index, lineProp}){
  _.forEach(['qty_to_receive','price', 'itemPriceError', 'price_tax_in', 'receiveInd','reference', 'mergeItem','cannotMerge', 'itemToMerge','purchase_unit_price'],prop=>{
    if(lineProp.hasOwnProperty(prop)){
      commit('SET_LINE_PROPERTY', {index, propName : prop, propVal:lineProp[prop]});
      if (prop === 'reference' || (prop === 'receiveInd' && lineProp[prop] === true)) {
        dispatch('validateItem', {index, reference: state.purchaseReceive.items[index].reference, inventoryId: state.inventory.id });
      }else if((prop === 'receiveInd' && lineProp[prop] === false)) {
        commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: null, index});
        commit('SET_LINE_PROPERTY', {index, propName : 'mergeItem', propVal:false});
        commit('SET_LINE_PROPERTY', {index, propName : 'cannotMerge', propVal:false});
      }

      if( prop === 'mergeItem' && lineProp[prop] === true){
        commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: null, index});
        commit('SET_LINE_PROPERTY', {index, propName : 'purchase_unit_price', propVal:state.purchaseReceive.items[index].itemToMerge.purchaseUnitPrice});
        commit('SET_LINE_PROPERTY', {index, propName : 'price', propVal:state.purchaseReceive.items[index].itemToMerge.price});
        commit('SET_LINE_PROPERTY', {index, propName : 'price_tax_in', propVal:state.purchaseReceive.items[index].itemToMerge.priceTaxIn});
      }else if(prop === 'mergeItem' && lineProp[prop] === false) {
        dispatch('validateItem', {index, reference: state.purchaseReceive.items[index].reference, inventoryId: state.inventory.id });
      }


    }
  })
}

const validateItem = function({state, commit, dispatch}, {index, reference, inventoryId}) {
  if (state.purchaseReceive.items[index].receiveInd === false) {
    return;
  }
  if (reference == null || reference === '') {
    return commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: 'Veuillez saisir un code de lot', index});
  } else if(_.get(state, 'inventory.code') === 'IP') {
    const regex = /\d-{1}\d/gm;
    const found = reference.match(regex);
    if (found == null) {
      return commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: "Veuillez assurer de saisir le code de lot d'arrivage composé de chiffres séparés par un tiret.", index});
    }
  }
  return ItemAPI.listItemsV2({reference, inventoryId})
    .then((items) => {
      if (!_.isEmpty(items)) {
        dispatch('setLineProp',{ index, lineProp:{itemToMerge : _.head(items) } });
        //Trigger une erreur
        if (_.get(_.head(items), 'puid') !== state.purchaseReceive.items[index].puid) {
          commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: 'Ce code de lot appartient à un produit différent. Veuillez en saisir un de nouveau.', index});
          dispatch('setLineProp',{ index, lineProp:{cannotMerge : true } });
        } else {
          commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: "Ce code de lot est déjà utilisé. Veuillez en saisir un nouveau ou l'ajouter au lot existant", index});
          dispatch('setLineProp',{ index, lineProp:{cannotMerge : false } });
        }

      }  else {
        commit('SET_LINE_PROP_ERROR', {prop: 'reference', value: null, index});
        dispatch('setLineProp',{ index, lineProp:{itemToMerge : null } });
        commit('SET_LINE_PROPERTY', {index, propName : 'mergeItem', propVal:false});
      }
    })


}

const initPurchaseReceive = function({commit, state, dispatch, rootState}, {purchaseOrder, receiveAll}){
  // console.log(purchaseOrder);
  commit('SET_LOADING', true);

  commit('SET_MAXIMUM_ITEM_PRICE_VARIATION',JSON.parse(localStorage.CONSIDER_ITEM_PRICE_VARIATION).maximum_item_price_variation);

  //On va chercher le statut du purchase receive (i.e. les quantit commandes et recu jusqu'à maintenant)
  return Promise.all([
    purchaseReceiveAPI.getPurchaseReceiveStatus(purchaseOrder.id),
    dispatch('inventory/fetchInventories',null,{root:true})
  ]).then(([purchaseReceiveStatus, inventory]) => {
    commit('SET_PURCHASE_RECEIVE_STATUS', purchaseReceiveStatus);

    dispatch('setPurchaseReceiveProp',{purchaseOrderId:purchaseOrder.id});
    dispatch('setPurchaseReceiveProp',{inventoryId:purchaseOrder.inventoryId});

    let inv = _.find(rootState.inventory.inventories, i=>{return i.id==state.purchaseReceive.inventoryId});
    commit('SET_INVENTORY', inv);

    dispatch('setPurchaseReceiveProp',{receiveAll});
    let items = [];

    return Promise.each(purchaseOrder.lines, line => {
      let prStatus = _.find(purchaseReceiveStatus, itemStatus=>{return itemStatus.product_id==line.product.id});
      // console.log(prStatus);
      let prLine = _.cloneDeep(line);
      prLine.receiveInd = receiveAll === true ? true : false;
      prLine.purchase_unit_price = line.purchase_unit_price;
      prLine.reference = line.reference;
      prLine.selling_unit_price = line.product.selling_unit_price;
      if (state.inventory != null && state.inventory.code !== 'IP' && state.inventory.code !== ' SAQ') {
        prLine.price = line.product.selling_unit_price;
      }
      prLine.cannotMerge = false;
      prLine.mergeItem = false;
      prLine.referenceError = null;
      prLine.qty_received = prStatus.qty_received;
      prLine.itemToMerge = null;
      prLine.itemPriceError = null;
      prLine.purchase_order_line_id = line.id;
      prLine.qty_to_receive = prLine.qty_ordered - prLine.qty_received;
      items.push(prLine);

    })
    .then(()=> {
      commit('SET_ITEMS', items);
      if(inv!=null && inv.delay_management){
        commit('SET_INVENTORY_LIMIT',inv.product_delay);
      }

      return Promise.each(state.purchaseReceive.items, (i, index) =>  dispatch('validateItem', {index, reference: i.reference, inventoryId: state.inventory.id }));
    }).then(()=> {
        commit('SET_LOADING', false);
    }).catch(err=>{
        commit('SET_LOADING', false);
        console.log("ERREUR : ", err);
    })

  })
}

const setItemPrice = function ({commit, state}, {index, price}){
  commit('SET_ITEM_PRICE', {index, price})
}

const postReceiveOrder = function ({commit,state}, receiveOrder){
  let postData = _.cloneDeep(state.purchaseReceive);
  let items = _.filter(state.purchaseReceive.items, i=> i.receiveInd === true);
  postData.items = items;

  let valid = true;

  if(postData.items.length === 0) {
    return Promise.reject("ITEMS_EMPTY");
  }

  _.forEach(postData.items, i=> {
    if (i.referenceError != null) valid = false
    if (i.puid == null) {
      i.puid = i.genericPuid;
      delete i.genericPuid;
    }
  })

  if (!valid) {
    return Promise.reject("REFERENCE_ERROR");
  } else {
    commit('SET_LOADING', true);
    return purchaseReceiveAPI.receivePurchaseOrder(postData)
      .then(()=>{
        commit('SET_LOADING', false);
      }).catch(err=>{
        commit('SET_LOADING', false);
        return err;
      })
  }


}
/*
* Fonction permettant de valider les règle en lien avec les prix variant des item
* @params index : Index de l'item dans le PR. Peut être null.
* @return True : si l'élément index validé est valide. Si index = null alors si tous les items sont valides
*         Faux : sinon
*         ATTENTION cela mets a jour l'attribut itemPriceError pour afficher les erreurs.
*/
const validateItemPriceVariation = function ({commit, state, dispatch}, index){

  function validateItem(price, selling_unit_price,state){
    let response = {};
    response.itemPriceError = null;
    response.valid=true;
    if(price==0){
      response.itemPriceError = "Le prix devrait être supérieur à 0.00$";
      response.valid = false;
    }else if(price > selling_unit_price){
      //Prix plus élevé que le prix du selling_unit_price
      response.itemPriceError = "Le prix devrait être inférieur au prix défini dans la définition du produit";
      response.valid = false;
    }else if((selling_unit_price-price)/selling_unit_price>state.maximumItemPriceVariation){
      //Prix trop bas et au dela du seuil de tolérance
      response.itemPriceError = "Le prix est plus bas que le seuil de tolérance de " + state.maximumItemPriceVariation*100 + '%' ;
      response.valid = false;
    }else if((selling_unit_price-price)/selling_unit_price<state.minimumItemPriceVariation){
      //Prix trop bas et au dela du seuil de tolérance
      response.itemPriceError = "Le prix est plus haut que le seuil de tolérance de " + state.maximumItemPriceVariation*100 + '%' ;
      response.valid = false;
    }
    return response;
  }

  let validatedItem = null;
  let valid = true;
  if(index!=null){
    if(state.purchaseReceive.items[index].qty_to_receive>0 && state.purchaseReceive.items[index].product!=null && state.purchaseReceive.items[index].product.agency_rate==null){
      validatedItem = validateItem(state.purchaseReceive.items[index].price, state.purchaseReceive.items[index].selling_unit_price,state);
      dispatch('setLineProp',{index,lineProp:{itemPriceError :validatedItem.itemPriceError}});
      // console.log(validatedItem);
      valid = validatedItem.valid;
    }
  }else{

    _.forEach(state.purchaseReceive.items, (item,index)=>{
      if(item.qty_to_receive>0 && state.purchaseReceive.items[index].product!=null && state.purchaseReceive.items[index].product.agency_rate==null){
        validatedItem = validateItem(item.price, item.selling_unit_price,state);
        dispatch('setLineProp',{index,lineProp:{itemPriceError :validatedItem.itemPriceError}});
        if(!validatedItem.valid){
          valid = false;
        }
      }
    })
  }
  if(valid){
    return Promise.resolve();
  }else{
    return Promise.reject();
  }
}


export default {
  reset,
  setPurchaseReceiveProp,
  initPurchaseReceive,
  postReceiveOrder,
  setLineProp,
  validateItemPriceVariation,
  validateItem,
};
